import React, { useContext, useState } from 'react'
import Scrollspy from 'react-scrollspy'

import MicrocopyContext from '~contexts/MicrocopyContext'

import style from './PageNav.module.scss'

const PageNav = ({
  links,
  hide = false
}) => {
  const microcopy = useContext(MicrocopyContext)
  const [selected, setSelected] = useState(null)

  const onUpdate = (element) => {
    setSelected(element?.id)
  }

  return !hide && links.length > 1 && (
    <Scrollspy 
      items={ links.map(({ href }) => href) } 
      className={style.nav} 
      rootEl='#scroll-body'
      onUpdate={onUpdate}
    >
      <header>{ microcopy.text('guides.titles.on_this_page', 'On this page') }</header> 
      { links.map((link, index) => (
        <li key={index} data-depth={link.depth}>
          <a 
            href={`#${link.href}`} 
            data-selected={selected === link.href}>
            { link.text }
          </a>
        </li>
      ))}
    </Scrollspy>
  )
}

export default PageNav
